import { render, staticRenderFns } from "./SiteAttachments.vue?vue&type=template&id=791f0cc2"
import script from "./SiteAttachments.vue?vue&type=script&lang=js"
export * from "./SiteAttachments.vue?vue&type=script&lang=js"
import style0 from "./SiteAttachments.vue?vue&type=style&index=0&id=791f0cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports